import { render, staticRenderFns } from "./saleTop.vue?vue&type=template&id=17049900&scoped=true&"
import script from "./saleTop.vue?vue&type=script&lang=js&"
export * from "./saleTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17049900",
  null
  
)

export default component.exports